// import React, { useState } from "react";
// import logo from "../assets/logo.png";
// import userIcon from "../assets/user.png";
// import { Link } from "react-router-dom";
// import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// const AdminHeader = () => {
//   const [show, setShow] = useState(false);
//   return (
//     <>
//       <header className="App-header navbar-top mb-3 mb-md-0">
//         {/* Top White Section */}
//         <nav className="navbar navbar-light navbar-glass navbar-top navbar-expand-lg">
//           <div className="px-3 px-md-4 w-100">
//             <div className="d-flex justify-content-between align-items-center w-100">
//               {/* Left - Logo */}
//               <div className="d-flex align-items-center">
//                 <span className="navbar-brand me-0 text-dark fs--2 fw-normal">
//                   <img src={logo} alt="logo" />
//                 </span>
//               </div>

//               {/* Center - Title */}
//               <div className="text-center flex-grow-1 d-none d-lg-block">
//                 <h5 className="fw-bold mb-0">Attendance Management System</h5>
//               </div>

//               {/* Right - User Icon */}
//               <div className="d-flex align-items-center">
//                 <div className="nav-item dropdown">
//                   <a
//                     className="nav-link p-0 pt-1"
//                     id="navbarDropdownUser"
//                     role="button"
//                     data-bs-toggle="dropdown"
//                     aria-haspopup="true"
//                     aria-expanded="false"
//                   >
//                     <img
//                       src={userIcon}
//                       alt="user"
//                       className="rounded-circle"
//                       style={{
//                         width: "40px",
//                         height: "40px",
//                         objectFit: "cover",
//                       }}
//                     />
//                   </a>
//                   <div
//                     className="dropdown-menu dropdown-caret dropdown-menu-end py-0"
//                     aria-labelledby="navbarDropdownUser"
//                   >
//                     <div className="bg-white rounded-2 py-2">
//                       <a className="dropdown-item" href="/">
//                         Logout
//                       </a>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </nav>

//         {/* Bottom Blue Navbar */}
//         <div className="bg-skyBlue">
//           <div className="px-3 px-md-4 container-fluid">
//             <ul
//               className="navbar-nav d-flex flex-row align-items-center gap-3 py-2"
//               data-top-nav-dropdowns="data-top-nav-dropdowns"
//             >
//               <li className="nav-item">
//                 <Link className="nav-link text-white fw-bold" to="/adminDashboard">
//                   Home
//                 </Link>
//               </li>

//               <li className="nav-item ">
//                 <Link className="nav-link  text-white fw-bold" to="/kitchenlist">
//                   Attendence List
//                 </Link>
//               </li>

//               <li className="nav-item dropdown">
//                   <a
//                     href="#"
//                     className="nav-link text-white fw-bold"
//                     onClick={(e) => {
//                       e.preventDefault();
//                       setShow(!show);
//                     }}
//                   >
//                     Master {show ? '▲' : '▼'}
//                   </a>
//                   {show && (
//                     <ul className="dropdown-menu show" style={{ position: 'absolute' }}>
//                       <li><Link className="dropdown-item" to="/employeeList">Employee List</Link></li>
//                       <li><Link className="dropdown-item" to="/kitchenlist">Kitchen List</Link></li>
//                     </ul>
//                   )}
//                 </li>
//             </ul>
//           </div>
//         </div>
//       </header>

//       {/* Custom Styles */}
//       <style>{`
//         @media (max-width: 991.98px) {
//           .navbar-nav {
//             flex-wrap: nowrap !important;
//           }
//           .navbar-nav .nav-item {
//             white-space: nowrap;
//           }
//         }

//         .dropdown-menu {
//           max-width: 250px;
//           overflow-x: hidden;
//           white-space: normal;
//         }

//         .navbar-nav {
//           overflow: visible !important;
//         }

//         @media (min-width: 992px) {
//           .navbar-nav {
//             flex-wrap: wrap !important;
//             gap: 1rem;
//           }
//         }
//       `}</style>
//     </>
//   );
// };

// export default AdminHeader; 


import React, { useState, useRef, useEffect } from "react";
import logo from "../assets/logo.png";
import userIcon from "../assets/user.png";
import { Link } from "react-router-dom";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const AdminHeader = () => {
  const [show, setShow] = useState(false);
  const dropdownRef = useRef();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShow(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      <header className="App-header navbar-top mb-3 mb-md-0">
        {/* Top White Section */}
        <nav className="navbar navbar-light navbar-glass navbar-top navbar-expand-lg">
          <div className="px-3 px-md-4 w-100">
            <div className="d-flex justify-content-between align-items-center w-100">
              {/* Left - Logo */}
              <div className="d-flex align-items-center">
                <span className="navbar-brand me-0 text-dark fs--2 fw-normal">
                  <img src={logo} alt="logo" />
                </span>
              </div>

              {/* Center - Title */}
              <div className="text-center flex-grow-1 d-none d-lg-block">
                <h5 className="fw-bold mb-0">Attendance Management System</h5>
              </div>

              {/* Right - User Icon */}
              <div className="d-flex align-items-center">
                <div className="nav-item dropdown">
                  <a
                    className="nav-link p-0 pt-1"
                    id="navbarDropdownUser"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <img
                      src={userIcon}
                      alt="user"
                      className="rounded-circle"
                      style={{
                        width: "40px",
                        height: "40px",
                        objectFit: "cover",
                      }}
                    />
                  </a>
                  <div
                    className="dropdown-menu dropdown-caret dropdown-menu-end py-0"
                    aria-labelledby="navbarDropdownUser"
                  >
                    <div className="bg-white rounded-2 py-2">
                      <a className="dropdown-item" href="/">
                        Logout
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>

        {/* Bottom Blue Navbar */}
        <div className="bg-skyBlue">
          <div className="px-3 px-md-4 container-fluid">
            <ul
              className="navbar-nav d-flex flex-row align-items-center gap-3 py-2"
              data-top-nav-dropdowns="data-top-nav-dropdowns"
            >
              <li className="nav-item">
                <Link className="nav-link text-white fw-bold" to="/adminDashboard">
                  Home
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link text-white fw-bold" to="/kitchenlist">
                  Attendance List
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link text-white fw-bold" to="/final-attendance-report-emp">
                  Attendance Report
                </Link>
              </li>

              {/* Fixed Master Dropdown */}
              <li className="nav-item dropdown" ref={dropdownRef}>
                <a
                  href="#"
                  className="nav-link text-white fw-bold dropdown-toggle"
                  onClick={(e) => {
                    e.preventDefault();
                    setShow(!show);
                  }}
                >
                  Master
                </a>
                {show && (
                  <ul className="dropdown-menu show" style={{ position: 'absolute' }}>
                    <li>
                      <Link className="dropdown-item" to="/employeeList">
                        Employee List
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/kitchenlist">
                        Kitchen List
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/employee-delete-list">
                        Exit Employee List
                      </Link>
                    </li>
                    <li><hr className="dropdown-divider" /></li>
                    <li><h6 className="dropdown-header text-primary">Leave Management</h6></li>
                    <li>
                      <Link className="dropdown-item" to="/kitchen-leave-policy">
                        Kitchen Leave Policy
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/leave-credits">
                        Employee Credits
                      </Link>
                    </li>
                    <li>
                     <Link className="dropdown-item" to="/leave-request">
                        Request Leave
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/leave-approvals">
                        Pending Approvals
                      </Link>
                    </li>
                     <li>
                      <Link className="dropdown-item" to="/leave-register" onClick={() => setShow(false)}>
                        Leave Register
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/global-holidays" onClick={() => setShow(false)}>
                        Holidays
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
            </ul>
          </div>
        </div>
      </header>

      {/* Custom Styles */}
      <style>{`
        @media (max-width: 991.98px) {
          .navbar-nav {
            flex-wrap: nowrap !important;
          }
          .navbar-nav .nav-item {
            white-space: nowrap;
          }
        }

        .dropdown-menu {
          max-width: 250px;
          overflow-x: hidden;
          white-space: normal;
          z-index: 1000;
        }

        .navbar-nav {
          overflow: visible !important;
        }

        @media (min-width: 992px) {
          .navbar-nav {
            flex-wrap: wrap !important;
            gap: 1rem;
          }
        }
      `}</style>
    </>
  );
};

export default AdminHeader;


















